const chars =
  "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789".split("");

const generate = (strlength = 5) => {
  let str = [];
  while (str.length < strlength) {
    str.push(chars[Math.round(Math.random() * (chars.length - 1))]);
  }
  return str.join("");
};

const list = [];

const guid = (length = 5) => {
  let str = generate(length);
  while (list.includes(str)) {
    str = generate(length);
  }
  list.push(str);
  return str;
};

export default guid;
